import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import SelectOption from "csi/middleware/customView/options/SelectOption";
import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { SizeChartReviewPrintOldReviewOptionsType } from "./CustomViewSizeChartOptions";
import SizeChartReviewDataSheetCustomViewOptionsStore from "./SizeChartReviewDataSheetCustomViewOptionsStore";

const SizeChartReviewDataSheetOptions: FunctionComponent = observer(function SizeChartReviewDataSheetOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		selectedReviewPrintOldReviews,
		setReviewPrintAllSuppliers,
		setReviewPrintEvaluationPerSize,
		setReviewPrintOldReviews,
		options: {
			reviewPrintAllSuppliers,
			reviewPrintEvaluationPerSize,
		},
		sizeChartDropDownOptions: {
			sizeChartReviewPrintOldReviewOptions,
		},
	} = optionsStore as SizeChartReviewDataSheetCustomViewOptionsStore;

	return (
		<>
			{isDefined(reviewPrintEvaluationPerSize) && (
				<CheckboxOption
					dataCsiAutomation="CustomViewDataSheetPrintReviewSizes"
					label="CustomViewDataSheetPrintReviewSizes"
					onChange={setReviewPrintEvaluationPerSize}
					optionValue={reviewPrintEvaluationPerSize}
					paddingLeft={0}
				/>
			)}
			{isDefined(selectedReviewPrintOldReviews) && (
				<SelectOption
					dataCsiAutomation="CustomViewDataSheetReviewPrintOldReviews"
					res="CustomViewDataSheetReviewPrintOldReviews"
					selectProps={{
						disabled: !reviewPrintEvaluationPerSize,
						onChange: setReviewPrintOldReviews,
						options: sizeChartReviewPrintOldReviewOptions,
						value: selectedReviewPrintOldReviews,
					}}
				/>
			)}
			{isDefined(reviewPrintAllSuppliers) && (
				<CheckboxOption
					dataCsiAutomation="CustomViewDataSheetReviewPrintAllSuppliers"
					disabled={selectedReviewPrintOldReviews.id === SizeChartReviewPrintOldReviewOptionsType.PRINT_REVIEWS_DEFAULT}
					label="CustomViewDataSheetReviewPrintAllSuppliers"
					onChange={setReviewPrintAllSuppliers}
					optionValue={reviewPrintAllSuppliers}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default SizeChartReviewDataSheetOptions;